import { markRaw } from 'vue'
import type { RegisteredComponent } from '@builder.io/sdk-vue'
import BaseBoosterYouTube from '~/components/BaseBoosterYouTube.vue'

export default <RegisteredComponent>{
  name: 'Base Booster YouTube Comp',
  tag: 'base-booster-youtube-comp',
  type: 'vue',
  component: markRaw(BaseBoosterYouTube),
  inputs: [
    {
      name: 'url',
      friendlyName: 'YouTube URL',
      helperText:
        'The full YouTube URL to render, for example: https://www.youtube.com/watch?v=dQw4w9WgXcQ',
      type: 'string',
      defaultValue: '',
    },
    {
      name: 'title',
      friendlyName: 'Video Title',
      helperText: 'Title used for accessibility and iframe metadata',
      type: 'string',
      defaultValue: 'YouTube Video',
    },
    {
      name: 'host',
      friendlyName: 'YouTube Host',
      helperText:
        'YouTube host URL. Keep default unless there is a specific embed requirement',
      type: 'string',
      defaultValue: 'https://www.youtube.com',
    },
    {
      name: 'options',
      friendlyName: 'Player Options',
      helperText:
        'Optional player options object that is passed directly to BoosterYoutube',
      type: 'object',
      defaultValue: {},
    },
    {
      name: 'mute',
      friendlyName: 'Start Muted',
      helperText: 'Starts the video muted when enabled',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'autoplay',
      friendlyName: 'Autoplay',
      helperText: 'Starts playback automatically when enabled',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'rounded',
      friendlyName: 'Rounded Corners',
      helperText: 'Applies rounded corner styling to the video wrapper',
      type: 'boolean',
      defaultValue: false,
    },
  ],
}
